import {
    BookingAttemptDto,
    SaveBookingAttemptDto
} from 'actions/bookingAttempts/BookingAttemptsDtos';
import { BookingAttempt, SaveBookingAttempt } from 'types/BookingAttempt';

export const convertToBookingAttempt = (dto: BookingAttemptDto): BookingAttempt => {
    return {
        sessionId: dto.session_id,
        marketplaceId: dto.marketplace_id,
        customerId: dto.customer_id,

        status: dto.status,

        lead: dto.lead,
        closed: dto.closed,
        notified: dto.notified,

        bookingData: dto.booking_data
    };
};

export const convertToSaveBookingAttemptDto = (
    sessionId: string,
    bookingAttempt: SaveBookingAttempt
): SaveBookingAttemptDto => {
    return {
        session_id: sessionId,
        marketplace_id: bookingAttempt.marketplaceId,
        customer_id: bookingAttempt.customerId,

        status: bookingAttempt.status,

        lead: bookingAttempt.lead,
        closed: bookingAttempt.closed,
        notified: bookingAttempt.notified,

        booking_data: bookingAttempt.bookingData
    };
};
